{
  "name": "depoto-client-v2",
  "version": "2.5.44",
  "lint-staged": {
    "*.{ts,js,html}": [
      "yarn lint",
      "prettier --write"
    ]
  },
  "scripts": {
    "ng": "ng",
    "build-info": "node scripts/write-build-info.mjs",
    "prestart": "yarn build-info",
    "start": "ng serve",
    "prebuild": "yarn build-info",
    "build": "ng build",
    "postbuild": "sh ./postbuild.sh",
    "prewatch": "yarn build-info",
    "watch": "ng build --watch --configuration development",
    "lint": "eslint src --fix",
    "lint-nofix": "eslint src",
    "lint:e2e": "eslint --no-ignore playwright playwright.config.ts && node scripts/check-playwright-hygiene.mjs",
    "prebuild-stats": "yarn build-info",
    "build-stats": "ng build --configuration production --stats-json",
    "bundle-analyze": "esbuild-visualizer --metadata dist/depoto-client-v2/stats.json --filename dist/depoto-client-v2/bundle-report.html --template treemap",
    "prebuild-deploy-stage": "yarn build-info",
    "build-deploy-stage": "ng build && sh deploy-stage.sh",
    "prebuild-deploy-prod": "yarn build-info",
    "build-deploy-prod": "ng build && sh deploy-prod.sh",
    "prehow-deploy-prod-v2": "yarn build-info",
    "how-deploy-prod-v2": "ng build && sh deploy-prod-v2.sh",
    "commit": "git-cz",
    "e2e": "yarn e2e:frontend",
    "e2e:frontend": "playwright test --project=frontend-chromium",
    "ci:start-dist": "sirv dist/depoto-client-v2 --single --port 4200 --quiet",
    "docs": "sh deploy-stage.sh",
    "postinstall": "husky",
    "release": "@microhoffman/release-it patch --ci --dry-run"
  },
  "private": true,
  "engines": {
    "node": ">=24.22.1 <25",
    "yarn": ">=1.22.22 <2"
  },
  "dependencies": {
    "@angular/animations": "^22.1.5",
    "@angular/cdk": "^22.1.5",
    "@angular/common": "^22.1.5",
    "@angular/compiler": "^22.1.5",
    "@angular/core": "^22.1.5",
    "@angular/forms": "^22.1.5",
    "@angular/platform-browser": "^22.1.5",
    "@angular/platform-browser-dynamic": "^22.1.5",
    "@angular/router": "^22.1.5",
    "@angular/service-worker": "^22.1.5",
    "@ckeditor/ckeditor5-angular": "10.1.0",
    "ckeditor5": "48.2.0",
    "@ng-select/ng-select": "^24.1.1",
    "@ngx-translate/core": "14.0.0",
    "@ngx-translate/http-loader": "7.0.0",
    "@sentry/angular": "10.62.0",
    "@tanstack/angular-query-experimental": "5.90.25",
    "@twogate/ngx-photo-gallery": "^1.8.1",
    "@types/deep-diff": "^1.0.5",
    "@types/lodash": "^4.17.20",
    "@types/lodash-es": "^4.17.12",
    "chardet": "^2.0.0",
    "deep-diff": "^1.0.2",
    "depoto-core": "git+https://gitlab.tomatom.cz/depoto-public/js-core.git#3.3.81",
    "graphql-request": "^7.2.0",
    "gs1-barcode-parser-mod": "^1.0.6",
    "html-validate": "^8.27.0",
    "iconv-lite": "^0.6.3",
    "jsbarcode": "^3.11.6",
    "lint-staged": "^15.2.11",
    "lodash": "^4.17.21",
    "lodash-es": "4.17.21",
    "moment": "^2.30.1",
    "ngx-bootstrap": "^22.0.0",
    "ngx-drag-drop": "^22.1.0",
    "ngx-dropzone": "3.1.0",
    "ngx-toastr": "^20.0.5",
    "qrcode": "^1.5.3",
    "reflect-metadata": "^0.2.2",
    "rxjs": "^7.8.1",
    "showdown": "^2.1.0",
    "tinycolor2": "^1.6.0",
    "tslib": "^2.6.2",
    "xlsx": "^0.18.5",
    "zone.js": "^0.15.1"
  },
  "devDependencies": {
    "@angular-eslint/builder": "22.3.0",
    "@angular-eslint/schematics": "22.3.0",
    "@angular/build": "^22.1.7",
    "@angular/cli": "^22.1.7",
    "@angular/compiler-cli": "^22.1.5",
    "@microhoffman/release-it": "^19.1.0",
    "@playwright/test": "^1.61.1",
    "@types/node": "^24.13.3",
    "@types/tinycolor2": "^1.4.6",
    "angular-eslint": "22.3.0",
    "esbuild-visualizer": "^0.7.0",
    "eslint": "^9.28.0",
    "eslint-config-prettier": "^9.1.0",
    "eslint-plugin-angular": "^4.1.0",
    "eslint-plugin-prettier": "5.2.1",
    "git-cliff": "2.8.0",
    "husky": "^9.1.7",
    "prettier": "^3.2.5",
    "prettier-eslint": "^13.0.0",
    "sirv-cli": "^3.0.1",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.69.0"
  },
  "resolutions": {
    "string-width": "4.2.3"
  },
  "config": {
    "commitizen": {
      "path": "@commitlint/prompt"
    }
  },
  "packageManager": "yarn@1.22.22+sha512.a6b2f7906b721bba3d67d4aff083df04dad64c399707841b7acf00f6b133b7ac24255f2652fa22ae3534329dc6180534e98d17432037ff6fd140556e2bb3137e"
}
